var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#A2B6C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29 15.8803L13.17 12.0003L9.29 8.12027C8.9 7.73027 8.9 7.10027 9.29 6.71027C9.68 6.32027 10.31 6.32027 10.7 6.71027L15.29 11.3003C15.68 11.6903 15.68 12.3203 15.29 12.7103L10.7 17.3003C10.31 17.6903 9.68 17.6903 9.29 17.3003C8.91 16.9103 8.9 16.2703 9.29 15.8803Z",
    fill: "#1E334E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskRightArrow);
export default __webpack_public_path__ + "static/media/task-right-arrow.bc792fa01959e026e3e1c1dca54ccffc.svg";
export { ForwardRef as ReactComponent };